import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { push } from 'react-router-redux';
import { addToast, saveToken, setCurrentTeam } from '../actions.export.js'

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// ACCEPT INVITE
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////


export const requestAcceptInvite = credentials => {
  return {
    type: 'REQUEST_ACCEPT_INVITE',
    data: {
      lastSubmit: credentials
    }
  }
}

export const receiveAcceptInviteSuccess = data => ({
  type: 'RECEIVE_ACCEPT_INVITE_SUCCESS',
  data
})

export const receiveAcceptInviteFail = data => ({
  type: 'RECEIVE_ACCEPT_INVITE_FAIL',
  data
})

export const tryToAcceptInvite = packet => dispatch => {
  dispatch(requestAcceptInvite(packet));
  
  return fetch('/api/teams/accept-invite', {
      method: 'put',
      body: JSON.stringify(packet),
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      let team = json.team;
      dispatch(receiveAcceptInviteSuccess(team));
      dispatch(setCurrentTeam(team.id));
      dispatch(push('/new/drawing'));
      dispatch(addToast({
        title: "You're on the team! 👍",
        detail: "You can now access and create patterns on the " + team.display_name + " team.",
        func: 'cookieToastDismissed',
        buttons: [
          {
            display: "Dismiss",
            dismissOnClick: true
          }
        ]
      }));
      dispatch(saveToken(json.token));
    })
    .catch(e => {
      revokeTokenHandler(e);
      dispatch(receiveAcceptInviteFail({errors:e, lastSubmit: packet}));
      return dispatch(push('/404'));
    })
}


// WEBPACK FOOTER //
// ./src/actions/team/a.t.PUT.accept-invite.js